import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';

type Stripe = Awaited<ReturnType<typeof loadStripe>>;

export function useStripe(publishableKey: string, options = {}) {
  const [stripe, setStripe] = useState<Stripe | null>(null);

  useEffect(() => {
    if (!stripe) {
      loadStripe(publishableKey, options)
        .then(
          // istanbul ignore next
          value => setStripe(value)
        )
        .catch(
          // istanbul ignore next
          err => {
            console.error(`Something went wrong loading Stripe: ${err}`);
          }
        );
    }
  }, []);

  return stripe;
}
